import { Team } from "~/api/Api";
import { isWhiteLabel } from "~/utils/white-label";

/**
 * An Autopto team on its trial subscription, a card or not. The backend
 * keeps the plan, the add-ons and the invoices closed all this time.
 */
export const isAutoptoTrialing = (team: Team | null | undefined) =>
  team?.platform === "autopto" && team.subscription?.status === "trialing";

/**
 * An Autopto agency in its trial: the countdown bar, the welcome view and
 * the launch checklist belong to this time only, with a card or without.
 * Once the trial is over they're gone, paid or not. Never on a white-label
 * host: that's the agency's own brand, not ours.
 */
export const isAutoptoTrial = (team: Team | null | undefined) =>
  !isWhiteLabel() && isAutoptoTrialing(team);

/**
 * An Autopto agency in its trial without a card yet: Team members, API
 * keys, Services and its own domain wait for one, and the trial asks for
 * it. A card opens them while the trial goes on.
 */
export const isAutoptoCardRequired = (team: Team | null | undefined) =>
  isAutoptoTrial(team) && Boolean(team?.autopto_card_required);

/**
 * The one-time offer due after the first card, for the admin: the upsell,
 * then the downsell once it's declined. Never on a white-label host.
 */
export const dueAutoptoOffer = (team: Team | null | undefined) =>
  isWhiteLabel() ? null : (team?.autopto_offer ?? null);
